import React from "react";
import "./Modal.scss"
import Heading from "../blockHeading/heading";
import HTMLReactParser from "html-react-parser";

const ActivityModal = props => {
  return(
      <div className="modalBox">
          <div className="modal">
              <span className="close-icon" onClick={props.handleClose}></span>
              <div className="blk-wysiwig">
                  {HTMLReactParser(props.data)}
              </div>
          </div>
      </div>
      )
}

export default ActivityModal